import { Rocket, Stethoscope, Droplets, Sprout, Boxes, Globe2 } from "lucide-react";
import { Reveal, SectionHeader } from "./Reveal";

const AUDIENCE_ICON_SIZE = 26;

const audiences = [
  { icon: Rocket, title: "Startups & D2C Brands", text: "First-time founders turning an idea into a shelf-ready product." },
  { icon: Stethoscope, title: "Healthcare Professionals", text: "Doctors and practitioners building their own trusted product lines." },
  { icon: Droplets, title: "Beauty & Wellness Brands", text: "Growing brands expanding into new categories and formats." },
  { icon: Sprout, title: "Ayurvedic Companies", text: "Authentic classical and proprietary Ayurvedic formulations, developed and manufactured with traditional knowledge and scientific understanding." },
  { icon: Boxes, title: "Established FMCG", text: "Enterprises seeking an agile, specialist formulation partner." },
  { icon: Globe2, title: "International & Export", text: "Businesses formulating for overseas markets and regulations." },
];

export default function WhoWeHelp() {
  return (
    <section data-testid="who-we-help-section" className="py-24 lg:py-32 bg-powder/50 border-y border-navy/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <SectionHeader overline="Who We Help" title={<>Built for the brands <em className="italic font-medium">of tomorrow.</em></>} />
        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {audiences.map(({ icon: Icon, title, text }, i) => (
            <Reveal key={title} delay={(i % 3) * 0.08} className="group bg-cream rounded-xl border border-navy/10 p-9 transition-transform duration-300 hover:-translate-y-1.5 hover:shadow-[0_16px_40px_rgba(62,74,46,0.1)]">
              <span className="grid place-items-center w-14 h-14 rounded-2xl bg-powder/70 border border-navy/15 text-navy transition-all duration-300 group-hover:bg-navy group-hover:text-cream group-hover:-translate-y-1">
                <Icon size={AUDIENCE_ICON_SIZE} strokeWidth={1.25} />
              </span>
              <h3 className="mt-6 font-display text-xl text-navy">{title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-charcoal/75">{text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
